export default __webpack_public_path__ + "static/media/redisimg.96c2d3bd.png";